import { OptimisticMessage } from 'widget_main/store/types';
import {
  Attachment,
  MessageCallbackResponse,
  SendMessageParameters,
} from 'core_main/sdk/send_message/types';
import {
  DISTANCE_TO_BOTTOM_FOR_LOCK,
  DISTANCE_TO_TOP_TO_LOAD_MORE,
} from './constants';

export const createOptimisticMessage = (
  sendMessagePayload: SendMessageParameters,
): OptimisticMessage => {
  const {
    body,
    payload,
    attachments,
    lastDeflection,
    isInAssistantMode,
    initAssistantPayload,
    lang,
  } = sendMessagePayload;
  return {
    messageId: String(Date.now()),
    body,
    payload,
    attachments: attachments?.map((attachment: Attachment) => ({
      attachmentId: String(Date.now()),
      file: attachment.file,
      url: attachment.url,
      name: attachment.file.name,
      contentLength: attachment.file.size,
      contentType: attachment.file.type,
    })),
    lastDeflection,
    isInAssistantMode,
    initAssistantPayload,
    lang,
    sentBy: {
      type: 'customer',
    },
  };
};
export const isLastMessageFromCustomer = (
  messages: MessageCallbackResponse[] | null,
) => {
  const lastMessageConvo = messages?.[messages.length - 1];

  return lastMessageConvo?.sentBy?.type === 'customer';
};

export const isScrolledToBottom = (element: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}) => {
  return (
    element.scrollHeight - element.scrollTop - DISTANCE_TO_BOTTOM_FOR_LOCK <=
    element.clientHeight
  );
};

export const isScrolledToTop = (element: { scrollTop: number }) => {
  return element.scrollTop <= DISTANCE_TO_TOP_TO_LOAD_MORE;
};

/// The time in ms to wait before ending the typing timeout
export const END_TYPING_TIMEOUT_MS = 20000; // 20 seconds

/// The timeout to end the typing indicator
let endTypingTimeout;

/// Clears the end typing indicator interval
export const clearEndTypingTimeout = () => {
  if (endTypingTimeout) {
    clearTimeout(endTypingTimeout);
    endTypingTimeout = undefined;
  }
};

/**
 * Starts the end typing interval
 * @param endTypingCallback The callback to call when the typing interval ends
 */
export const startEndTypingTimeout = (endTypingCallback: () => void) => {
  clearEndTypingTimeout();
  endTypingTimeout = setTimeout(() => {
    endTypingCallback(); // Call the provided callback
    clearEndTypingTimeout();
  }, END_TYPING_TIMEOUT_MS);
};
